import React, { useState } from "react";
import {
  Box,
  Drawer as MuiDrawer,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  CssBaseline,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  Divider,
  Tooltip,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { NavLink, useLocation } from "react-router-dom";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LogoApp from "../../img/logo.png";
import { useSelector } from "react-redux";
import User from "../user";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import { useDispatch } from "react-redux";
import { toggleSidebar, setSidebarOpen } from "../../redux/sidebar/sidebarSlice";
import StorefrontIcon from "@mui/icons-material/Storefront";

const drawerWidth = 260;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "white",
  boxShadow: "none",
  borderBottom: "1px solid #ddd",
}));

const StyledList = styled(List)({
  "&& .Mui-selected, && .Mui-selected:hover": {
    backgroundColor: "red",
    "&, & .MuiListItemIcon-root": {
      color: "pink",
    },
  },
  "& .MuiSvgIcon-root": { color: "#FFFFFF" },
  "& .active .MuiListItemButton-root": {
    backgroundColor: "#fff",
    "& .MuiSvgIcon-root, &, & .MuiListItemIcon-root": { color: "red" },
  },
  "& .MuiListItemButton-root": { color: "#fff" },
  "& .MuiListItemButton-root:hover": {
    backgroundColor: "#FFF",
    "&, & .MuiListItemIcon-root": {
      color: "red",
    },
    "& .MuiSvgIcon-root": { color: "red" },
  },
});

const hwset = { height: "18px", width: "18px" };

export default function MiniDrawer() {
  const location = useLocation();
  // const [open, setOpen] = useState(false);
  const [openRoyalty, setOpenRoyalty] = useState(false);
  const userData = useSelector((state) => state.userData.userData);
  const isUserDataEmpty =
    !userData?.brand_name ||
    !userData?.avatar_url ||
    !userData?.authentic_brand ||
    !userData?.brand;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sidebar.open);

  const navItems = [
    {
      id: 6,
      to: "/influencers",
      text: "Influencers",
      tooltip: "Influencers",
      icon: <ReusableMuiIcons name="people" tooltip="" />,
    },
    {
      id: 2,
      to: "/event",
      text: "Event Sponsorship",
      tooltip: "Event Sponsorship",
      icon: <ReusableMuiIcons name="calender" tooltip="" />,
    },
    {
      id: 3,
      // to: "/offer-management",
      to: "/new-offer",
      text: "Offer Management",
      tooltip: "Offer Management",
      icon: <ReusableMuiIcons name="offer" tooltip="" />,
    },

    {
      id: 4,
      to: "/gig-management",
      text: "Gig Management",
      tooltip: "Gig Management",
      icon: <ReusableMuiIcons name="news" tooltip="" />,
    },
    {
      id: 7,
      to: "/affiliate-commerce",
      text: "Affiliate Commerce",
      tooltip: "Products, commission and creator earnings",
      icon: <StorefrontIcon />,
    },
    {
      id: 5,
      to: "/internship",
      text: "Internship management",
      tooltip: "Internship management",
      icon: <ReusableMuiIcons name="scholer" tooltip="" />,
    },
    // {
    //   id: 3,
    //   to: "/new-offer",
    //   text: "New Offer Management",
    //   tooltip: "New Offer Management",
    //   icon: <ReusableMuiIcons name="offer" tooltip="" />,
    // },
  ];

  const handleDrawerOpen = () => {
    dispatch(toggleSidebar());
  };

  const handleNavItemClick = () => {
    if (isMobile) {
      dispatch(setSidebarOpen(false));
    }
  };

  const listRender = (item) => {
    const listButton = (
      <ListItemButton
        className={`${open ? "" : "pb-0"} rounded-3`}
        onClick={handleNavItemClick}
        sx={{
          minHeight: 48,
          paddingTop: 0,
          marginTop: "10px !important",
          justifyContent: open ? "initial" : "center",
          flexDirection: open ? "" : "column",
          alignItems: open ? "" : "center",
          px: 2.5,
          position: "relative",
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : "0px",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {item.icon}
          {item.hasCollapse && !open ? (
            <ChevronRightIcon
              sx={{
                position: "absolute",
                right: "3px",
                top: "7px",
                width: "18px",
                height: "18px",
              }}
            />
          ) : null}
        </ListItemIcon>
        {/* <ListItemText
          primary={
            <Typography
              component="span"
              variant="body2"
              sx={
                !open
                  ? {
                      fontSize: "11px",
                      display: item.text.length > 10 ? "block" : "inline-block",
                      whiteSpace: item.text.length > 10 ? "break-spaces" : "nowrap",
                      textAlign: "center",
                    }
                  : {}
              }
            >
              {item.text}
            </Typography>
          }
        /> */}
        {(open || isMobile) && (
          <ListItemText
            primary={
              <Typography
                component="span"
                variant="body2"
                sx={
                  !open
                    ? {
                      fontSize: "11px",
                      display: item.text.length > 10 ? "block" : "inline-block",
                      whiteSpace: item.text.length > 10 ? "break-spaces" : "nowrap",
                      textAlign: "center",
                    }
                    : {}
                }
              >
                {item.text}
              </Typography>
            }
          />
        )}
        {item.hasCollapse && open
          ? openRoyalty
            ? <ExpandLess />
            : <ExpandMore />
          : null}
      </ListItemButton>
    );

    return open ? (
      listButton
    ) : (
      <Tooltip title={item.tooltip || item.text} placement="right" arrow>
        {listButton}
      </Tooltip>
    );
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar className="bg-white shadow-none border" position="fixed" open={open}>
        <Toolbar>
          {!isUserDataEmpty && location?.pathname !== "/profile-completion" ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className="text-black ms-1"
              edge="start"
            >
              <MenuOpenIcon />
            </IconButton>
          ) : null}
          <Box sx={{ marginLeft: 4 }}>
            <img src={LogoApp} alt="Logo" style={{ width: "135px" }} />
          </Box>
          <Box className="d-flex align-items-center gap-5 w-100 justify-content-end">
            <User />
          </Box>
        </Toolbar>
      </AppBar>
      {!isUserDataEmpty && location?.pathname !== "/profile-completion" ? (
        <MuiDrawer
          variant={isMobile ? "temporary" : "permanent"}
          open={open}
          onClose={() => dispatch(setSidebarOpen(false))}
          sx={{
            width: isMobile ? drawerWidth : open ? drawerWidth : 70,
            flexShrink: 0,
            whiteSpace: "nowrap",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            "& .MuiDrawer-paper": {
              width: isMobile ? drawerWidth : open ? drawerWidth : 70,
              marginTop: isMobile ? "" : "4rem",
              padding: "10px",
              boxSizing: "border-box",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              background: "linear-gradient(180deg, #ED1C24 0%, #AA0066 100%)",
              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.55)",
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
            },
          }}
          ModalProps={{ keepMounted: true }}
        >
          <List
            sx={{ width: "100%", maxWidth: 360, paddingBottom: "5rem !important" }}
            className="p-0"
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            {isMobile ? (
              <DrawerHeader>
                <IconButton onClick={handleNavItemClick}>
                  <ChevronLeftIcon fontSize="large" sx={{ color: "white" }} />
                </IconButton>
              </DrawerHeader>
            ) : null}

            <Divider sx={{ color: "white" }} />
            <StyledList sx={{ padding: "0px" }}>
              {navItems.map((item) => (
                <NavLink
                  key={item.id}
                  to={item.to}
                  className={`nav-list-items text-decoration-none ${location.pathname.includes(item.to) ? "active" : ""
                    }`}
                >
                  {listRender(item)}
                </NavLink>
              ))}
            </StyledList>
          </List>
        </MuiDrawer>
      ) : null}
    </Box>
  );
}
